import { MessageActions } from '../types';

export const updateFrameHeight = (field: string, sessionId: string, libInitializeId: string) => {
  const height = document.body.scrollHeight;
  window.parent.postMessage({
    action: MessageActions.RESIZE_FRAME,
    field,
    height,
    sessionId,
    libInitializeId,
  }, '*');
};
